import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import FlDmvDetailedRenewalModal from './FlDmvDetailedRenewalModal';
import FlIntegrationService from '../../../../../service/FlIntegrationService';

class FlDmv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'plateNumber',
        display: 'Plate Number',
      },
      {
        value: 'hsmvReceiptNumber',
        display: 'HSMV Receipt Number',
      },
    ];

    this.allowedKeys = [ 'id', 'customerId', 'hsmvReceiptNumber', 'renewalDate', ];
  }

  FLDMV = 'fldmv';

  onRowSelect(selectedRow) {
    const { renewalRows, } = this.state;

    const renewal = renewalRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedRenewal: renewal.raw,
    });
  }

  getRenewals(event) {
    this.reset();
    const { search, combo, } = event;
    const criteria = {};

    let value = search.value;
    if (combo.value === 'plateNumber' && value) {
      value = value.toUpperCase();
    }
    criteria[combo.value] = value;

    FlIntegrationService.getFlRenewalBySearchCriteria(criteria)
      .then((response) => {
        const { renewals, } = response.data;

        const headers = this.allowedKeys.map(header => ({
          value: header,
          display: _.startCase(header),
        }));
        const rows = [];

        renewals.forEach((renewal) => {
          const filtered = _.pick(renewal, this.allowedKeys);
          filtered.renewalDate = moment(filtered.renewalDate)
            .utc()
            .format();

          rows.push({
            value: Object.values(filtered),
            raw: renewal,
          });
        });

        this.setState({
          renewalHeaders: headers,
          renewalRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  reset() {
    this.setState({
      renewalHeaders: [],
      renewalRows: [],
      selectedRenewal: null,
    });
  }

  showSelectedDetails(selectedRenewal) {
    if (!selectedRenewal) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${selectedRenewal.id}`}</p>
        <hr />
        <div className="m-1">
          <FlDmvDetailedRenewalModal renewal={selectedRenewal} />
        </div>
      </div>
    );
  }

  render() {
    const { renewalHeaders = [], renewalRows = [], selectedRenewal, } = this.state;

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getRenewals(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Renewals">
            <Grid
              headers={renewalHeaders}
              rows={renewalRows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              onRowSelect={row => this.onRowSelect(row)}
            />
          </FieldSet>
          {this.showSelectedDetails(selectedRenewal)}
        </div>
      </div>
    );
  }
}

export default FlDmv;
